import { render, staticRenderFns } from "./add_department.vue?vue&type=template&id=0d5d9462&scoped=true&"
import script from "./add_department.vue?vue&type=script&lang=js&"
export * from "./add_department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d9462",
  null
  
)

export default component.exports